import { Component, computed, inject, OnInit, Signal, ChangeDetectionStrategy } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { FestivalsStore } from '../../../store/festivals/festivals.store';
import { Festival, UtilSelect } from '@shared';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'active-festival',
  imports: [SelectModule, FormsModule],
  templateUrl: './active-festival.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './active-festival.component.scss',
})
export class ActiveFestivalComponent implements OnInit {
  readonly #festivalsStore = inject(FestivalsStore);

  selectedFestivalId: Signal<number> = this.#festivalsStore.selectedFestivalId;
  selectedValue = computed(() => this.selectedFestivalId() ?? '*');
  isPending: Signal<boolean> = this.#festivalsStore.isPending;
  festivals: Signal<Festival[]> = this.#festivalsStore.festivals;
  festivalOptions: Signal<UtilSelect[]> = computed(() => {
    const options =
      this.festivals()?.map((festival: Festival) => ({
        name: festival.title,
        value: festival.id,
      })) || [];
    return [{ name: 'Alle', value: '*' }, ...options];
  });

  ngOnInit() {
    this.#festivalsStore.fetchFestivalsDefault();
  }

  setSelectedFestival({ value }): void {
    this.#festivalsStore.setSelectedFestivalId(value === '*' ? null : value);
  }
}
